/* eslint-disable prettier/prettier */
import { Client } from "@microsoft/microsoft-graph-client";
import React from "react";
import { IDocuments } from "./interfaces";
import {

    DetailsList, DetailsListLayoutMode, FontSizes, FontWeights, IColumn, IconButton,// mergeStyleSets, Callout, DirectionalHint, 
    MessageBar, MessageBarType, SelectionMode, Spinner, SpinnerSize,
    Toggle
} from "@fluentui/react";
import { theme } from "./Module";


interface IContainedDocsProps {
    client: Client;
    siteId: string;
    listName: string;
    eTag: string;
    preview: (url: string) => void;

}
interface IContainedDocsState {
    items: IDocuments[];
    sharedLinkCreated: boolean;
    wait: boolean;
    show: boolean;
    index?: string;
    filelink?: string;
    previewOn: boolean;
}
//const styles2 = mergeStyleSets({ callout: { width: 500, height: 500, padding: '10px 14px', border: '0' }, title: { marginBottom: 12, fontWeight: FontWeights.semilight, }, buttons: { display: 'flex', justifyContent: 'flex-end', marginTop: 20, } });

export class ContainedDocs extends React.Component<IContainedDocsProps, IContainedDocsState> {
    protected items: IDocuments[] = [];
    protected columns: IColumn[] = [];
    protected targetButton: any;
    constructor(props: IContainedDocsProps) {
        super(props);
        this.state = { items: [], sharedLinkCreated: false, wait: true, show: true, previewOn: false };
        // this.renderDocumentRow = this.renderDocumentRow.bind(this);
        this.columns = [{
            key: 'column1', name: 'File Details', onColumnClick: this._onColumnClick,
            onRender: (item: any //IDocument
            ) => {
                return <div style={{ textAlign: "left" }}


                >
                    <div style={{ fontWeight: FontWeights.semibold, fontSize: FontSizes.smallPlus, color: theme.palette.neutralPrimary }}>
                        <IconButton styles={{ root: { color: theme.palette.red, padding: 0, margin: 0, fontWeight: FontWeights.bold } }} title="Click Here To Create A shareable Link" iconProps={{ iconName: 'AddLink' }} disabled={false} checked={false} onClick={() => {

                            this.props.client
                                .api(`https://graph.microsoft.com/v1.0/sites/${this.props.siteId}/lists/${this.props.listName}/items/${item.eTag}/createLink`)
                                .header("Content-Type", "application/json")
                                .post({ body: JSON.stringify({ "type": "View" }) })
                                .then((res) => {
                                    item.link = res.link.webUrl;
                                    // eslint-disable-next-line no-undef
                                    const dummy = document.createElement("textarea");
                                    // eslint-disable-next-line no-undef
                                    document.body.appendChild(dummy);
                                    dummy.value = res.link.webUrl;
                                    dummy.select();
                                    // eslint-disable-next-line no-undef
                                    document.execCommand("copy");
                                    // eslint-disable-next-line no-undef
                                    document.body.removeChild(dummy);
                                    // eslint-disable-next-line no-undef
                                    //  navigator.clipboard.writeText(res.link.webUrl);
                                    this.setState({ sharedLinkCreated: true });
                                })
                                .catch(error => {
                                    // eslint-disable-next-line no-undef
                                    console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${this.props.siteId}/lists/${this.props.listName}/items/${item.eTag}/createLink`, '  ', error);
                                })


                        }} />
                        <IconButton styles={{ root: { color: theme.palette.red, padding: 0, margin: 0, fontWeight: FontWeights.bold } }} title="Preview the document" iconProps={{ iconName: 'ComplianceAudit' }} disabled={false} checked={false} onClick={() => {

                            this.props.preview(item.downloadUrl);
                            //  this.props.preview('https://psarakisantonis-my.sharepoint.com/personal/psarakisantonis_e-study_gr/Documents/Documents/20761A-ENU-TrainerHandbook.pdf')
                            //   window.open('https://psarakisantonis-my.sharepoint.com/personal/psarakisantonis_e-study_gr/Documents/Documents/20761A-ENU-TrainerHandbook.pdf', "_blank");

                        }} />
                        {item.name}</div>

                    <div id={'X' + item.id} style={{ fontSize: FontSizes.small, color: theme.palette.blackTranslucent40, paddingLeft: 10 }}> {new Date(item.createdDateTime).toLocaleString('el-GR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        // second: '2-digit',
                        hour12: false,
                    })}  <span style={{ paddingLeft: 30 }}> {item.lastModifiedBy}</span></div>
                    {/* <div style={{ fontSize: FontSizes.small }}><Link href={item.path} target="_blank">{item.path}</Link></div> */}
                </div>;
            },
            minWidth: 0, maxWidth: 250, currentWidth: 250
        },];
        this.targetButton = React.createRef();
    }
    private _onColumnClick() { }
    // private preview(): void {
    //     // console.log('preview', list);
    //     Office.context.ui.openBrowserWindow('https://psarakisantonis-my.sharepoint.com/personal/psarakisantonis_e-study_gr/Documents/Documents/20761A-ENU-TrainerHandbook.pdf');
    //     //  window.window.open('https://psarakisantonis-my.sharepoint.com/personal/psarakisantonis_e-study_gr/Documents/Documents/20761A-ENU-TrainerHandbook.pdf', "_blank");

    // }
    componentDidMount(): void {
        let url: string = '';
        if (this.props.eTag === '') {
            url = `https://graph.microsoft.com/v1.0/sites/${this.props.siteId}/lists/${this.props.listName}/drive/root/children?$top=5000`
        }
        else {
            url = `https://graph.microsoft.com/v1.0/sites/${this.props.siteId}/lists/${this.props.listName}/drive/items/${this.props.eTag}/children?$top=5000`
        }
        //   https://graph.microsoft.com/v1.0/sites/440debda-2842-415b-b18c-35413e988f38/lists/documents/drive/items?$filter=folder eq null&$top=5000


        this.props.client
            // .api(`https://graph.microsoft.com/v1.0/sites/ecd79cb3-fbd4-4c1e-a8d3-782209e8d176/lists/Documents/drive/items/88CB3252-BAEF-4FA0-A068-203FB88B312A/children?$top=5000`)
            .api(url)
            //.filter("folder eq null")
            .get()
            .then((response: any) => {
                response.value.filter(x => x.folder == undefined).forEach(element => {
                    this.items.push({
                        downloadUrl: element.webUrl,
                        eTag: element.eTag.split(",")[0].replace(/{/g, "").replace(/}/g, "").replace(/"/g, ""),
                        createdDateTime: element.createdDateTime,
                        id: element.id,
                        lastModifiedBy: element.lastModifiedBy.user != undefined && element.lastModifiedBy.user.displayName != undefined ? element.lastModifiedBy.user.displayName : element.lastModifiedBy.user.email,
                        name: element.name.toUpperCase(),
                        size: element.size,
                        siteId: this.props.siteId,
                        driveId: element.parentReference.driveId,
                        listName: this.props.listName
                    });
                });
                let sortedItems = this.items.sort(
                    (p1, p2) => (p1.name < p2.name) ? -1 : (p1.name > p2.name) ? 1 : 0);
                this.setState({ items: sortedItems, wait: false });
            });



    }


    // // eslint-disable-next-line no-undef
    // public renderDocumentRow(props: any, defaultRender: any): JSX.Element {
    //     //   const filelink = props.item.ServerRedirectedEmbedURL !== undefined && props.item.ServerRedirectedEmbedURL && props.item.ServerRedirectedEmbedURL;
    //     return (
    //         <div

    //             onClick={() => {
    //                 // window.open(filelink, "_blank");
    //             }}

    //         >
    //             {defaultRender(props)}
    //         </div>);
    // }
    public render(): React.ReactNode {

        return <div ref={this.targetButton} >

            <div style={{ height: 30 }}>
                {this.state.sharedLinkCreated &&
                    <MessageBar
                        messageBarType={MessageBarType.success}
                        isMultiline={false}
                        onDismiss={() => { this.setState({ sharedLinkCreated: false }) }}
                        dismissButtonAriaLabel="Close"
                    >
                        Link copied succeffully to clipboard

                    </MessageBar>
                }
            </div>
            <div >
                {this.state.wait &&
                    <Spinner size={SpinnerSize.large} ></Spinner>
                }
                {!this.state.wait &&
                    // <div onMouseOut={() => {
                    //     this.setState({ show: false, });
                    // }}>
                    <DetailsList

                        // items={this._allItems}
                        items={this.state.items}
                        columns={this.columns}
                        styles={{ root: { fontSize: '11px', width: '100%' } }}
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        selectionMode={SelectionMode.none}
                    //    onRenderRow={this.renderDocumentRow}

                    />
                    // </div>

                }



            </div>

        </div>
    }

}







